import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TRAINERS } from "../content";

const Postmark = () => (
  <div
    className="pointer-events-none absolute right-2 top-4 z-10 flex h-20 w-20 rotate-12 items-center justify-center rounded-full border-2 border-dashed border-[#FF008B]/50 bg-white/90 text-center shadow-md sm:-right-3 sm:-top-3 sm:h-24 sm:w-24"
    aria-hidden="true"
  >
    <div className="flex h-14 w-14 flex-col items-center justify-center rounded-full border border-[#FF008B]/30 sm:h-16 sm:w-16">
      <span className="text-[0.5rem] font-extrabold uppercase tracking-widest text-[#FF008B] sm:text-[0.55rem]">
        eduNation
      </span>
      <span className="text-[#242344]">✦</span>
      <span className="text-[0.45rem] font-bold uppercase tracking-widest text-[#68677A] sm:text-[0.5rem]">
        kurs online
      </span>
    </div>
  </div>
);

export default function HeroShowcase() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const t = TRAINERS[active];

  useEffect(() => {
    if (paused) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const id = window.setInterval(() => {
      setActive((a) => (a + 1) % TRAINERS.length);
    }, 4000);
    return () => window.clearInterval(id);
  }, [paused]);

  return (
    <div
      data-testid="hero-showcase"
      className="relative rounded-3xl border border-[#EAE6F0] bg-white pb-5 pt-8 shadow-xl shadow-[#242344]/10"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="airmail-edge absolute inset-x-0 top-0 rounded-t-3xl" aria-hidden="true" />
      <Postmark />

      <div className="relative mx-4 aspect-[4/5] overflow-hidden rounded-2xl bg-[#FAF8FC] sm:mx-6 sm:aspect-square">
        <AnimatePresence mode="wait">
          <motion.img
            key={t.id}
            src={t.photo}
            alt={`Prelegentka kursu: ${t.name}`}
            width="768"
            height="768"
            className="h-full w-full object-cover"
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
          />
        </AnimatePresence>

        <div className="absolute bottom-3 left-3 rounded-xl bg-[#242344]/90 px-4 py-2 backdrop-blur-sm">
          <p className="text-sm font-bold text-white sm:text-base">{t.name}</p>
          <p className="text-[0.65rem] font-semibold uppercase tracking-wider text-white/70">
            prelegentka kursu
          </p>
        </div>

        <img
          src="/assets/keyvisual.png"
          alt="Key visual kursu z brytyjskimi motywami"
          loading="lazy"
          className="absolute right-3 top-3 h-14 w-14 rotate-3 rounded-lg border-2 border-white object-cover shadow-lg sm:h-16 sm:w-16"
        />
      </div>

      <div className="mx-4 mt-4 flex items-center justify-between gap-3 sm:mx-6">
        <div className="flex -space-x-2.5" role="group" aria-label="Wybierz prelegentkę">
          {TRAINERS.map((tr, i) => (
            <button
              key={tr.id}
              type="button"
              data-testid={`hero-avatar-${tr.id}`}
              onClick={() => {
                setActive(i);
                setPaused(true);
              }}
              aria-pressed={i === active}
              aria-label={`Pokaż zdjęcie: ${tr.name}`}
              className={`relative h-9 w-9 overflow-hidden rounded-full border-2 bg-white shadow-sm transition-all duration-200 sm:h-12 sm:w-12 ${
                i === active
                  ? "z-10 scale-110 border-[#FF008B] ring-2 ring-[#FFB3DA]"
                  : "border-white hover:z-10 hover:scale-110 hover:border-[#FFB3DA]"
              }`}
            >
              <img src={tr.photo} alt="" loading="lazy" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
        <p className="shrink-0 text-[0.6rem] font-bold uppercase tracking-wide text-[#68677A] sm:text-xs">
          7 prelegentek
        </p>
      </div>
    </div>
  );
}
